import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import DataTable from '../../components/Common/DataTable';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { PlusIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

const DeviceTypes = () => {
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { get, del } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeviceTypes();
  }, []);

  const fetchDeviceTypes = async () => {
    setLoading(true);
    const { data } = await get('/api/device-types');
    if (data) setDeviceTypes(data);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this device type?')) {
      const { error } = await del(`/api/device-types/${id}`);
      if (!error) {
        fetchDeviceTypes();
      }
    }
  };

  const columns = [
    { header: 'ID', accessor: 'id' },
    { header: 'Description', accessor: 'description' },
    { header: 'Information', accessor: 'information' },
    { 
      header: 'Actions', 
      accessor: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => navigate(`/device-types/edit/${row.id}`)}
            className="text-blue-600 hover:text-blue-900"
            title="Edit"
          >
            <PencilIcon className="h-5 w-5" />
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            className="text-red-600 hover:text-red-900"
            title="Delete"
          >
            <TrashIcon className="h-5 w-5" />
          </button>
        </div>
      )
    }
  ];

  if (loading) return <LoadingSpinner />;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Device Types</h1>
        <button
          onClick={() => navigate('/device-types/add')}
          className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 flex items-center space-x-2"
        >
          <PlusIcon className="h-5 w-5" />
          <span>Add Device Type</span>
        </button>
      </div>

      <DataTable 
        columns={columns} 
        data={deviceTypes}
      />
    </div>
  );
};

export default DeviceTypes;